import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"

export enum MysteryAssets {
    HOSPITAL = "MysteryHOSPITAL",

    ECIGARETTE = "MysteryECIGARETTE",
    INHALER = "MysteryINHALER",
    EAR = "MysteryEAR",
    HEART = "MysteryHEART",
    LUNGS = "MysteryLUNGS",
    JAROFTAR = "MysteryJAROFTAR",
    OXYGENMASK = "MysteryOXYGENMASK",
    STETHOSCOPE = "MysterySTETHOSCOPE",
    CLOGGEDARTERY = "MysteryCLOGGEDARTERY",
    TODDLER = "MysteryTODDLER",

    CAR = "MysteryCAR",
    A1 = "MysteryA1",
    A2 = "MysteryA2",
    A3 = "MysteryA3",
    A4 = "MysteryA4",
    B1 = "MysteryB1",
    B2 = "MysteryB2",
    B3 = "MysteryB3",
    B4 = "MysteryB4",
    C1 = "MysteryC1",
    C2 = "MysteryC2",
    C3 = "MysteryC3",
    C4 = "MysteryC4",

    INTRO_1 = "MysteryINTRO_1",
    INTRO_2 = "MysteryINTRO_2",
    INTRO_3 = "MysteryINTRO_3",
    CLUE_BREATHING_1 = "MysteryCLUE_BREATHING_1",
    CLUE_ASTHMA_1 = "MysteryCLUE_ASTHMA_1",
    CLUE_EAR = "MysteryCLUE_EAR",
    CLUE_HEART_1 = "MysteryCLUE_HEART_1",
    CLUE_CANCER = "MysteryCLUE_CANCER",
    CLUE_BREATHING_2 = "MysteryCLUE_BREATHING_2",
    CLUE_ASTHMA_2 = "MysteryCLUE_ASTHMA_2",
    CLUE_LUNG = "MysteryCLUE_LUNG",
    CLUE_HEART_2 = "MysteryCLUE_HEART_2",
    CLUE_NICOTINE = "MysteryCLUE_NICOTINE",
    ALRIGHT = "MysteryALRIGHT",
    SOLVE = "MysterySOLVE",
    PIECES_TOGETHER = "MysteryPIECES_TOGETHER",
    WHICH_EFFECTS = "MysteryWHICH_EFFECTS",
    OUTRO_1 = "MysteryOUTRO_1",
    OUTRO_2 = "MysteryOUTRO_2",
}

export function loadAssets(game: Phaser.Game) {
    game.load.image(
        MysteryAssets.HOSPITAL,
        CCUtils.asset("mystery/hospital.png"),
    )

    game.load.image(
        MysteryAssets.ECIGARETTE,
        CCUtils.asset("mystery/hunt/ecigarette.png"),
    )
    game.load.image(
        MysteryAssets.INHALER,
        CCUtils.asset("mystery/hunt/inhaler.png"),
    )
    game.load.image(MysteryAssets.EAR, CCUtils.asset("mystery/hunt/ear.png"))
    game.load.image(
        MysteryAssets.HEART,
        CCUtils.asset("mystery/hunt/heart.png"),
    )
    game.load.image(
        MysteryAssets.LUNGS,
        CCUtils.asset("mystery/hunt/lungs.png"),
    )
    game.load.image(
        MysteryAssets.JAROFTAR,
        CCUtils.asset("mystery/hunt/jar-of-tar.png"),
    )
    game.load.image(
        MysteryAssets.OXYGENMASK,
        CCUtils.asset("mystery/hunt/oxygen-mask.png"),
    )
    game.load.image(
        MysteryAssets.STETHOSCOPE,
        CCUtils.asset("mystery/hunt/stethoscope.png"),
    )
    game.load.image(
        MysteryAssets.CLOGGEDARTERY,
        CCUtils.asset("mystery/hunt/clogged-artery.png"),
    )
    game.load.image(
        MysteryAssets.TODDLER,
        CCUtils.asset("mystery/hunt/toddler.png"),
    )

    game.load.image(MysteryAssets.CAR, CCUtils.asset("mystery/puzzle/car.png"))

    game.load.image(MysteryAssets.A1, CCUtils.asset("mystery/puzzle/A1.png"))
    game.load.image(MysteryAssets.A2, CCUtils.asset("mystery/puzzle/A2.png"))
    game.load.image(MysteryAssets.A3, CCUtils.asset("mystery/puzzle/A3.png"))
    game.load.image(MysteryAssets.A4, CCUtils.asset("mystery/puzzle/A4.png"))
    game.load.image(MysteryAssets.B1, CCUtils.asset("mystery/puzzle/B1.png"))
    game.load.image(MysteryAssets.B2, CCUtils.asset("mystery/puzzle/B2.png"))
    game.load.image(MysteryAssets.B3, CCUtils.asset("mystery/puzzle/B3.png"))
    game.load.image(MysteryAssets.B4, CCUtils.asset("mystery/puzzle/B4.png"))
    game.load.image(MysteryAssets.C1, CCUtils.asset("mystery/puzzle/C1.png"))
    game.load.image(MysteryAssets.C2, CCUtils.asset("mystery/puzzle/C2.png"))
    game.load.image(MysteryAssets.C3, CCUtils.asset("mystery/puzzle/C3.png"))
    game.load.image(MysteryAssets.C4, CCUtils.asset("mystery/puzzle/C4.png"))

    game.load.audio(
        MysteryAssets.INTRO_1,
        CCUtils.asset("mystery/audio/mystery-game-intro-1.mp3"),
    )
    game.load.audio(
        MysteryAssets.INTRO_2,
        CCUtils.asset("mystery/audio/mystery-game-intro-2.mp3"),
    )
    game.load.audio(
        MysteryAssets.INTRO_3,
        CCUtils.asset("mystery/audio/mystery-game-intro-3.mp3"),
    )
    game.load.audio(
        MysteryAssets.CLUE_BREATHING_1,
        CCUtils.asset("mystery/audio/mystery-game-clue-breathing-1.mp3"),
    ) // E-cigarette
    game.load.audio(
        MysteryAssets.CLUE_ASTHMA_1,
        CCUtils.asset("mystery/audio/mystery-game-clue-asthma-1.mp3"),
    ) // Inhaler
    game.load.audio(
        MysteryAssets.CLUE_EAR,
        CCUtils.asset("mystery/audio/mystery-game-clue-ear.mp3"),
    ) // Ear
    game.load.audio(
        MysteryAssets.CLUE_HEART_1,
        CCUtils.asset("mystery/audio/mystery-game-clue-heart-1.mp3"),
    ) // Heart
    game.load.audio(
        MysteryAssets.CLUE_CANCER,
        CCUtils.asset("mystery/audio/mystery-game-clue-cancer.mp3"),
    ) // Lungs
    game.load.audio(
        MysteryAssets.CLUE_BREATHING_2,
        CCUtils.asset("mystery/audio/mystery-game-clue-breathing-2.mp3"),
    ) // Tar
    game.load.audio(
        MysteryAssets.CLUE_ASTHMA_2,
        CCUtils.asset("mystery/audio/mystery-game-clue-asthma-2.mp3"),
    ) // Oxygen mask
    game.load.audio(
        MysteryAssets.CLUE_LUNG,
        CCUtils.asset("mystery/audio/mystery-game-clue-lung.mp3"),
    ) // Stethoscope
    game.load.audio(
        MysteryAssets.CLUE_HEART_2,
        CCUtils.asset("mystery/audio/mystery-game-clue-heart-2.mp3"),
    ) // Artery
    game.load.audio(
        MysteryAssets.CLUE_NICOTINE,
        CCUtils.asset("mystery/audio/mystery-game-clue-nicotine.mp3"),
    ) // Toddler
    game.load.audio(
        MysteryAssets.ALRIGHT,
        CCUtils.asset("mystery/audio/mystery-game-alright.mp3"),
    )
    game.load.audio(
        MysteryAssets.SOLVE,
        CCUtils.asset("mystery/audio/mystery-game-solve.mp3"),
    )
    game.load.audio(
        MysteryAssets.PIECES_TOGETHER,
        CCUtils.asset("mystery/audio/mystery-game-pieces-together.mp3"),
    )
    game.load.audio(
        MysteryAssets.WHICH_EFFECTS,
        CCUtils.asset("mystery/audio/mystery-game-which-effects.mp3"),
    )
    game.load.audio(
        MysteryAssets.OUTRO_1,
        CCUtils.asset("mystery/audio/mystery-game-outro-1.mp3"),
    )
    game.load.audio(
        MysteryAssets.OUTRO_2,
        CCUtils.asset("mystery/audio/mystery-game-outro-2.mp3"),
    )
}
